if(!customElements.get('location-checker')) {
    class LocationChecker extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            this.selectors = {
                zipInput: this.querySelector('#location-search'),
                result: this.querySelector('.result-details'),
                resultFound: this.querySelector('.result-details .found'),
                resultNotFound: this.querySelector('.result-details .not-found'),
                btnSearch: this.querySelector('.search button'),
                notifyEmail: this.querySelector('.notify-email'),
                email: this.querySelector('#notify-email'),
                notifyBtn: this.querySelector('.notify-email button'),
                notifySuccess: this.querySelector('.notify-success'),
                notifyClose: this.querySelector('.notify-success button'),
                notifyError: this.querySelector('.notify-error')
            };
                        
            this.selectors.zipInput.addEventListener('keydown', async (event) => {
                if(event.key === 'Enter') {
                    const zipValue = event.target.value;
                    if(zipValue === '') {
                        this.selectors.notifyError.classList.add('zip-code-empty');
                        return;
                    }
                    if(zipValue.length < 5) {
                        this.selectors.notifyError.classList.add('invalid-format');
                        return;
                    }
                    this.searchZipCode(zipValue);
                    this.selectors.btnSearch.classList.add('loading');
                }
            });

            this.selectors.zipInput.addEventListener('input', (event) => {
                const input = event.target;
                input.value = input.value.toUpperCase();
                this.selectors.notifyError.classList.remove('invalid-format');
                this.selectors.notifyError.classList.remove('zip-code-empty');
                this.selectors.result.classList.remove('found', 'not-found');
                this.selectors.resultFound.classList.remove('active');
                this.selectors.resultNotFound.classList.remove('active');
            });

            this.selectors.btnSearch.addEventListener('click', async () => {
                    const zipValue = this.selectors.zipInput.value;
                    if(zipValue === '') {
                        this.selectors.notifyError.classList.add('zip-code-empty');
                        return;
                    }
                    if(zipValue.length < 5) {
                        this.selectors.notifyError.classList.add('invalid-format');
                        return;
                    }
                    this.searchZipCode(zipValue);
                    this.selectors.btnSearch.classList.add('loading');
            });

            this.selectors.email.addEventListener('keydown', async (event) => {
                if(event.key === 'Enter') {
                    const email = event.target.value.trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if(email === '' || !email) {
                        this.selectors.notifyError.classList.add('email-empty');
                        this.selectors.notifyError.classList.remove('invalid-email');
                        return;
                    }
                    if(emailRegex.test(email)) {
                        const zipCode = this.selectors.zipInput.value;
                        this.notifyEmailSubmit(zipCode, email);
                        this.selectors.notifyBtn.classList.add('loading');
                    } else {
                        this.selectors.notifyError.classList.add('invalid-email');
                        this.selectors.notifyError.classList.remove('email-empty');
                        return;
                    }
                }
            })

            this.selectors.notifyBtn.addEventListener('click', () => {
                    const email = this.selectors.email.value.trim();
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if(email === '' || !email) {
                        this.selectors.notifyError.classList.add('email-empty');
                        this.selectors.notifyError.classList.remove('invalid-email');
                        return;
                    }
                    if(emailRegex.test(email)) {
                        const zipCode = this.selectors.zipInput.value;
                        this.notifyEmailSubmit(zipCode, email);
                        this.selectors.notifyBtn.classList.add('loading');
                    } else {
                        this.selectors.notifyError.classList.add('invalid-email');
                        this.selectors.notifyError.classList.remove('email-empty');
                        return;
                    }
            })

            this.selectors.email.addEventListener('input', (event) => {
                const email = event.target.value.trim();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                this.selectors.notifyError.classList.remove('invalid-email');
                this.selectors.notifyError.classList.remove('email-empty');
                if(!emailRegex.test(email)) {
                  return;
                }
            })

            this.selectors.notifyClose.addEventListener('click', () => {
                this.selectors.notifySuccess.classList.remove('active');
                this.selectors.zipInput.value = '';
                this.selectors.email.value = '';
            })
        }
        
        async searchZipCode(zipCode) {
            await fetch('https://tyrlurpqfczmohfmhngv.supabase.co/functions/v1/check-delivery-zone', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5cmx1cnBxZmN6bW9oZm1obmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1MjMwNjEsImV4cCI6MjA3ODA5OTA2MX0.VyKDYiB6_hvI510C8lPNJERLrN75Rk9Fe5TRGe90y2o',
                    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5cmx1cnBxZmN6bW9oZm1obmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1MjMwNjEsImV4cCI6MjA3ODA5OTA2MX0.VyKDYiB6_hvI510C8lPNJERLrN75Rk9Fe5TRGe90y2o'
                    },
                    body: JSON.stringify({
                    zipCode: zipCode,
                    email: null
                    })
                })
                .then(res => res.json())
                .then(data => {
                    this.selectors.btnSearch.classList.remove('loading');
                    if(data.found) {
                        this.logZipCodeSearch(zipCode, data.found, data.pricing);
                        this.selectors.result.classList.add('found');
                        let resultFoundText = this.selectors.resultFound.innerHTML;
                        this.selectors.resultFound.innerHTML = resultFoundText.replace('[pricing]', data.pricing);
                        this.selectors.resultFound.classList.add('active');
                        this.selectors.notifyEmail.classList.remove('active');
                    } else {
                        this.selectors.result.classList.add('not-found');
                        this.selectors.resultNotFound.classList.add('active');
                        this.selectors.notifyEmail.classList.add('active');
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
        async logZipCodeSearch(zipCode, found, pricing, email = null) {
            const SUPABASE_URL = 'https://tyrlurpqfczmohfmhngv.supabase.co';
            const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5cmx1cnBxZmN6bW9oZm1obmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1MjMwNjEsImV4cCI6MjA3ODA5OTA2MX0.VyKDYiB6_hvI510C8lPNJERLrN75Rk9Fe5TRGe90y2o';
            try {
                const response = await fetch(`${SUPABASE_URL}/rest/v1/zip_code_searches`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
                        'apikey': SUPABASE_ANON_KEY,
                        'Content-Type': 'application/json',
                        'Prefer': 'return=minimal' // Do not return the inserted row, just get a 201 Created
                    },
                    body: JSON.stringify({
                        zip_code: zipCode,
                        found: found,
                        pricing: pricing,
                        email: email
                        // Add any other columns your table requires here
                    })
                });

                if (response.status === 201) {
                    console.log('✅ Zip code search saved successfully!');
                    return { success: true, status: response.status };
                } else {
                    const errorText = await response.text();
                    console.error('❌ Failed to save search:', {
                        status: response.status,
                        statusText: response.statusText,
                        error: errorText
                    });
                    return { 
                        success: false, 
                        status: response.status,
                        error: errorText 
                    };
                }
            } catch (error) {
                console.error('❌ Network or other error:', error);
                return { 
                    success: false, 
                    error: error.message 
                };
            }
        }
        async notifyEmailSubmit(zipCode, email, found = false, pricing = '') {
            const SUPABASE_URL = 'https://tyrlurpqfczmohfmhngv.supabase.co';
            const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR5cmx1cnBxZmN6bW9oZm1obmd2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1MjMwNjEsImV4cCI6MjA3ODA5OTA2MX0.VyKDYiB6_hvI510C8lPNJERLrN75Rk9Fe5TRGe90y2o';
            try {
                const response = await fetch(`${SUPABASE_URL}/rest/v1/zip_code_searches`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
                        'apikey': SUPABASE_ANON_KEY,
                        'Content-Type': 'application/json',
                        'Prefer': 'return=minimal' // Do not return the inserted row, just get a 201 Created
                    },
                    body: JSON.stringify({
                        zip_code: zipCode,
                        found: found,
                        pricing: pricing,
                        email: email
                        // Add any other columns your table requires here
                    })
                });

                if (response.status === 201) {
                    this.selectors.result.classList.remove('not-found');
                    this.selectors.resultNotFound.classList.remove('active');
                    this.selectors.notifyEmail.classList.remove('active');
                    this.selectors.notifySuccess.classList.add('active');
                    console.log('✅ Zip code search saved successfully!');
                    return { success: true, status: response.status };
                    
                } else {
                    const errorText = await response.text();
                    console.error('❌ Failed to save search:', {
                        status: response.status,
                        statusText: response.statusText,
                        error: errorText
                    });
                    return { 
                        success: false, 
                        status: response.status,
                        error: errorText 
                    };
                }
            } catch (error) {
                console.error('❌ Network or other error:', error);
                return { 
                    success: false, 
                    error: error.message 
                };
            }
        }
    }
    
    customElements.define('location-checker', LocationChecker);
}